<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section aria-labelledby="pt1" epub:type="part" role="doc-part">
<header>
<h1 class="Part-Number-pn" id="pt1"><span aria-label="9" id="pg_9" role="doc-pagebreak"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">PART I</span></span></h1>
<h1 class="Part-Title-pt"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample">HOW TO MAKE A MILLIONAIRE</span></h1>
</header>
<p class="Part-Epigraph-non-verse-pepi"><i>The only way to do great work is to love what you do.</i></p>
<p class="Part-Epigraph-Source-peps"><i class="part-epigraph-source-peps-_span-italic-characters-ital">—</i><span class="pepc_CAPS">C</span><span class="small">ONDÉ</span> <span class="pepc_CAPS">N</span><span class="small">AST (AND LATER,</span> <span class="pepc_CAPS">S</span><span class="small">TEVE</span> <span class="pepc_CAPS">J</span><span class="small">OBS)</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?7df8c43c